<script lang="ts">
	import { browser } from '$app/environment';
	import { afterNavigate } from '$app/navigation';
	import { page } from '$app/stores';
	import Nav from '$lib/components/base/Nav.svelte';
	import { ETheme } from '$lib/dto/ETheme';
	import { equalsAny } from '$lib/svelte-utils/utils/stringUtils';
	import { appTheme } from '$lib/utils/themeUtils';
	import { onDestroy, onMount, tick } from 'svelte';
	import '../app.css';
	import GlobalCss from './GlobalCss.svelte';

	export let data;

	let navBarElement1: HTMLElement;
	let navBarElement2: HTMLElement;
	let contentContainer: HTMLElement;

	let lastScrollPosition = -1;

	$: hasOwnTopBar =
		$page.url.pathname.startsWith('/review/') ||
		$page.url.pathname == '/docs' ||
		$page.url.pathname.startsWith('/docs/');

	onMount(() => {
		if ($page.data.showTranslucentNavBar) {
			lastScrollPosition = contentContainer.scrollTop;
			contentContainer.addEventListener('scroll', onScrollListener);
		}
		$appTheme = document.documentElement.classList.contains('dark') ? ETheme.Dark : ETheme.Light;
	});

	afterNavigate(async (nav) => {
		// Scrolling bug: https://github.com/sveltejs/kit/issues/2733#issuecomment-1891244568
		if (equalsAny(nav.type, 'enter', 'link') && nav.to?.url.toString().includes('/blog/')) {
			await tick();
			contentContainer.scrollTop = 0;

			if (nav.type === 'link') {
				setTimeout(() => {
					contentContainer.scrollTop = 0;
				}, 100);
			}
		}
	});

	function onScrollListener() {
		const scrollingUp = contentContainer.scrollTop - lastScrollPosition;
		const navbarElement = navBarElement1 || navBarElement2;
		if (contentContainer.scrollTop < 50 || scrollingUp <= 0) {
			navbarElement.style.top = '0';
		} else {
			navbarElement.style.top = `${-contentContainer.scrollTop}px`;
		}
		lastScrollPosition = contentContainer.scrollTop;
	}

	onDestroy(() => browser && contentContainer?.removeEventListener('scroll', onScrollListener));
</script>

<GlobalCss />

<div class="flex h-full flex-col">
	{#if !hasOwnTopBar}
		{#if $page.data.showTranslucentNavBar}
			<div
				class="h-[4px] bg-gradient-to-r from-orange-400 via-pink-400 to-blue-300 dark:from-sky-500 dark:via-pink-600 dark:to-blue-900"
			/>
			<div
				bind:this={navBarElement1}
				class="absolute left-0 right-0 flex-initial rounded-t transition-all"
				class:bg-white={lastScrollPosition > 50}
				class:dark:bg-black={lastScrollPosition > 50}
			>
				<Nav translucent roundedTop />
			</div>
		{:else}
			<div bind:this={navBarElement2} class="flex-initial">
				<Nav />
			</div>
		{/if}
	{/if}

	<div bind:this={contentContainer} class:flex-1={hasOwnTopBar} class="overflow-auto">
		<slot />
	</div>
</div>

<svelte:head>
	{#if data.enableCloudMode}
		<script type="text/javascript">
			(function () {
				var sbSiteSecret = '29bbca84-fc2d-420c-b7ff-55cdaa72e30d';
				window.sitebehaviourTrackingSecret = sbSiteSecret;
				var scriptElement = document.createElement('script');
				scriptElement.async = true;
				scriptElement.id = 'site-behaviour-script-v2';
				scriptElement.src =
					'https://sitebehaviour-cdn.fra1.cdn.digitaloceanspaces.com/index.min.js?sitebehaviour-secret=' +
					sbSiteSecret;
				document.head.appendChild(scriptElement);
			})();
		</script>
	{/if}
</svelte:head>
